interface Props {
  src: string
  title: string
}

export const SummaryImage: React.FC<Props> = ({ src, title }) => {
  return (
    <div>
      <img
        src={src}
        alt={title}
        className="my-0 mx-auto w-[130px] align-middle bg-[#ccc] shadow-flier"
      />
    </div>
  )
}
